import type { ReactNode } from 'react';

export const symbol_antigravity: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M483-880q81 0 124 60t75 137q26 65 50 142.5t51.51 154.48Q810-312 842.5-245.5 875-179 917-130q8 10 8 21t-8 19q-8 8-20 8.5T875-89q-82-63-128-141.5t-99.21-136.1Q613-405 572.7-428q-40.3-23-89.5-23t-89.7 23q-40.5 23-75.29 61.4Q265-309 219-230.5 173-152 91-89q-10 8-22 7.5T49-90q-8-8-8-19t8-21q42-49 74.5-115.5t58.99-140.52Q210-463 234-540.5 258-618 284-683q30.7-76.83 74.35-136.92Q402-880 483-880Zm-86.5 108.5Q366-723 343-670q-33 75-56.5 156.5T235-357q25.96-34.08 49.98-60.04Q309-443 334-462q35-25 70.5-37t78.5-12q43 0 78.5 12t70.5 37q25 19 49.02 44.96Q705.04-391.08 731-357q-28-75-51.5-156.5T623-670q-23-53-53.5-101.5T483-820q-56 0-86.5 48.5ZM483-511Z"
		/>
	</svg>
);
